import { get, omit, range } from "lodash-es";
import React, { useState } from "react";
import { DeepMap, FieldError } from "react-hook-form";
import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";

import { FancyButtonLink } from "shared/components/Link";
import { Spacer } from "shared/layout";
import { Icon } from "shared/styles";

import { FileUpload, FileUploadProps } from "./FileUpload";

interface Props extends FileUploadProps {
  errors: DeepMap<Record<string, any>, FieldError>;
}

export const FilesUpload: React.FC<Props> = ({ name, errors, validation, value, ...rest }) => {
  const [nbFiles, setNbFiles] = useState(Object.keys(value || {}).length || 1);

  return (
    <Spacer size="s">
      <Spacer size="xxs">
        {range(nbFiles).map(index => {
          const isFirstFile = index === 0;
          const id = `${name}.${index}`;

          return (
            <FileUpload
              key={id}
              {...rest}
              name={id}
              hideLabel={!isFirstFile}
              error={get(errors, id)}
              value={get(value, id) || get(value, index)}
              validation={isFirstFile ? validation : omit(validation, "required")}
            />
          );
        })}
      </Spacer>
      <FancyButtonLink onClick={() => setNbFiles(nbFiles + 1)}>
        <Spacer spaceDirection="horizontal" size="xxs" align="center">
          <Icon as={Plus} />
          <span>{copy.form.addFile}</span>
        </Spacer>
      </FancyButtonLink>
    </Spacer>
  );
};
